module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	'use strict';

	fox.registerWidget('Intercom_MC', {
		configure: function(options) {
			this.registerOptions('', {
				customLauncher: false
			});

			this.callParent('configure', arguments);
		},
		
		handleEnabledState: function(o, w) {
			fox.Consent.check('cookiesFunctional').then(function(data) {
				if (data) {
					if (w.getOption(this.getOption('widgetOption')) === false) {
						this.disableIC();
					} else if (w.getOption(this.getOption('widgetOption')) === true) {
						this.enableIC();
					} else {
						if (this.getOption('defaultState')) {
							this.enableIC();
						} else {
							this.disableIC();
						}
					}
				}
			}.bind(this)).catch(function() {
				// console.log('intercom', w.getOption(this.getOption('widgetOption')), this.getOption('defaultState'));
				// this.disableIC();
				this.shutdown();
			}.bind(this));

			
		},

		shutdown: function() {
			window.Intercom('shutdown');
		}

	}, 'Intercom');
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/intercom.js
// module id = 311
// module chunks = 2